import { GROUP } from '../EnumTypes/ActionEnumTypes';
import { Connector } from 'Modules/GroupModule';
import * as ViewManagementModule from 'Modules/ViewManagementModule';

const init = () => ({
  type: GROUP.GET_GROUP_ID_USERS_INIT,
});

const success = (groupUsers) => ({
  type: GROUP.GET_GROUP_ID_USERS_SUCCESS,
  payload: {
    groupUsers,
  },
});

const failure = () => ({
  type: GROUP.GET_GROUP_BY_ID_FAILURE,
});

const getGroupUsers = (id) => async (dispatch) => {
  dispatch(init());
  try {
    dispatch(ViewManagementModule.Actions.showLoader());
    const { data } = await Connector.getGroupUsers(id);
    dispatch(success(data.users));
    dispatch(ViewManagementModule.Actions.hideLoader());
  } catch (err) {
    dispatch(ViewManagementModule.Actions.hideLoader());
    dispatch(failure());
  }
};

export default getGroupUsers;
